import React from 'react';
import { useSelector } from 'react-redux';

import Carousel from './Carousel';
import Modal from '../Modal';

import s from './index.module.css';
import { getExpertMode, getExpertsList } from '../../store/selectors';

const DEFAULT_EXPERT_AVATAR_URL = process.env.PUBLIC_URL + '/static/defaultExpert.png';

const ExpertsCarousel = () => {
  const experts = useSelector(getExpertsList);
  const mode = useSelector(getExpertMode);

  const handleImageError = (e) => {
    e.target.src = DEFAULT_EXPERT_AVATAR_URL;
  };

  const showCarousel = mode === 'carousel' && experts.length > 0;

  return showCarousel && (
    <Modal
      className={s.modal}
      withOverlay={false}
      showClose={false}
    >
      <div className={s.carouselBody}>
        <div className={s.headerWrapper}>
          <h2 className={s.carouselHeader}>Помощь уже рядом</h2>
          <p className={s.carouselInfo}>Дождитесь соединения с экспертом Смартби</p>
        </div>
          <Carousel>
          {experts.map((expert) => (
            <div className={s.expertWrapper} key={expert.id}>
              <img
                className={s.expertPhoto}
                src={expert.photoPath.includes('https://smartbe.ru') ? expert.photoPath : `https://smartbe.ru${expert.photoPath}`} alt={`expert-${expert.name}`}
                onError={handleImageError}
              />
              <p className={s.expertName}>{expert.name}</p>
            </div>
          ))}
        </Carousel>
      </div>
    </Modal>
  );
};

export default ExpertsCarousel;